module.exports = __webpack_public_path__ + "static/media/lr.e3059e98.svg";